import pl from './pl';

/** All Polish UI strings for the contact-request epic. Import this instead of writing inline text. */
export const CONTACT_REQUEST_LABELS = pl;
